
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-trial",
      function () {
        return require("private-next-pages/free-trial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-trial"])
      });
    }
  